window.globalHelpersModule.directive "insurancePlan", 
['$rootScope', '$log', '$timeout', '$state', ($rootScope, $log, $timeout, $state) ->
  restrict: "E"

  link: (scope, element, attrs) ->

  templateUrl: 'portal/profile/insurance-plan-directive-template.html'
]